import { __rest } from "tslib";
import React from 'react';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import { menu, maxHeightVar } from './menu.css';
import { cn, mergeProps } from '~/utils';
const MENU_NAME = 'vulcanui-menu';
const MIN_HEIGHT = 80;
const Menu = React.forwardRef((props, ref) => {
    const { className, children, as: Comp = 'ul', maxHeight = 300, style = {} } = props, restProps = __rest(props, ["className", "children", "as", "maxHeight", "style"]);
    if (maxHeight < MIN_HEIGHT)
        console.warn(`The minimum height of the menu is ${MIN_HEIGHT}px`, 'Menu');
    return (React.createElement(Comp, Object.assign({ ref: ref, style: mergeProps(assignInlineVars({
            [maxHeightVar]: `${maxHeight < MIN_HEIGHT ? MIN_HEIGHT : maxHeight}px`
        }), style), className: cn(MENU_NAME, className, menu) }, restProps), children));
});
Menu.displayName = 'Menu';
Menu.toString = () => `.${MENU_NAME}`;
export default Menu;
//# sourceMappingURL=menu.js.map